/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class AssignEngineersSuccess extends React.Component<*> {
  componentDidMount() {
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const engineers: Object = actionDrawerStore.response.project.engineers;
    const projectDetails: Object = this.props.projectDetailsStore.details;

    projectDetails.engineers = engineers;
  }

  renderItems = () => {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const engineers: Object = actionDrawerStore.response.engineers;

    return engineers.map((engineer: Object) => (
      <ul key={engineer.id}>
        <li>
          <b>{`${engineer.name}`}</b>
        </li>
        <li>{`${t('general:roles.labels.current_role')}: ${t(
          `general:roles.${engineer.role_id}`
        )}`}</li>
      </ul>
    ));
  };

  render(): React.Node {
    const { t }: TranslatorProps = this.props;
    const actionDrawerStore: TypeActionDrawerStore = this.props.actionDrawerStore;
    const project: Object = actionDrawerStore.response.project;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={false}
            gutters={true}
            heading={t('general:engineers.assigned')}
          >
            <p>
              {t('general:engineers.messages.assigned_to_project', {
                title: `${project.code} - ${project.name}`,
              })}
            </p>
            <React.Fragment>{this.renderItems()}</React.Fragment>
          </ActionDrawerBlock>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
